import LikeForm from './LikeForm'

export default LikeForm
